<div class="assignment-address">
  <div class="content">
    <div class="assignment-section">
      <dx-data-grid
        id="loadunits-grid"
        [dataSource]="addresses()"
        keyExpr="Id"
        [showRowLines]="true"
        [showColumnLines]="false"
        [showBorders]="false"
        [allowColumnReordering]="false"
        [allowColumnResizing]="false"
        class="custom-grid"
        style="width: 100%">
        <!-- Paging and Scrolling Configurations -->
        <dxo-paging [pageSize]="120"></dxo-paging>
        <dxo-scrolling
          mode="infinite"
          [useNative]="false"
          [scrollByContent]="true"
          [scrollByThumb]="true"
          showScrollbar="onHover">
        </dxo-scrolling>

        <!-- Master Grid Columns -->
        <dxi-column
          dataField="ChangedDateTime"
          [caption]="'ASSIGNMENT.ADDRESS.CHANGEDDATETIME' | translate"
          dataType="datetime"
          alignment="center"
          [allowSorting]="false"
          format="dd.MM.yy HH:mm">
        </dxi-column>
        <dxi-column
          dataField="ChangedBy"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.ADDRESS.CHANGEDBY' | translate"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="Type"
          [caption]="'ASSIGNMENT.ADDRESS.DELIVERYPICKUP' | translate"
          alignment="center"
          [allowSorting]="false"
          cellTemplate="cellTemplate">
          <!-- Custom cell template for the Type column -->
          <div *dxTemplate="let data of 'cellTemplate'">
            <app-icon [kind]="data.text"></app-icon>
          </div>
        </dxi-column>
        <dxi-column
          dataField="EventStartDate"
          [caption]="'ASSIGNMENT.ADDRESS.EVENTSTARTDATE' | translate"
          dataType="date"
          alignment="center"
          [allowSorting]="false"
          format="dd.MM.yy">
        </dxi-column>
        <dxi-column
          dataField="EventStartTime"
          [caption]="'ASSIGNMENT.ADDRESS.EVENTSTARTTIME' | translate"
          dataType="time"
          alignment="center"
          [allowSorting]="false"
          format="HH:mm">
        </dxi-column>
        <dxi-column
          dataField="EventEndDate"
          [caption]="'ASSIGNMENT.ADDRESS.EVENTENDDATE' | translate"
          dataType="date"
          alignment="center"
          [allowSorting]="false"
          format="dd.MM.yy">
        </dxi-column>
        <dxi-column
          dataField="EventEndTime"
          [caption]="'ASSIGNMENT.ADDRESS.EVENTENDTIME' | translate"
          dataType="time"
          alignment="center"
          [allowSorting]="false"
          format="HH:mm">
        </dxi-column>

        <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

        <!-- Master-Detail Template placed inside the dx-data-grid -->
        <div *dxTemplate="let address of 'detail'">
          <table class="detail-table" style="width: 100%; border-collapse: collapse">
            <!-- Row 1: Address and Strasse -->
            <tr>
              <td style="padding: 2px 5px; vertical-align: top; white-space: nowrap">
                <strong>{{ 'ASSIGNMENT.ADDRESS.ADDRESS' | translate }}:</strong>
              </td>
              <td style="padding: 2px 5px; vertical-align: top; text-align: left">
                {{ address.data.Address }}
              </td>
              <td style="padding: 2px 5px; vertical-align: top; white-space: nowrap">
                <strong>{{ 'ASSIGNMENT.ADDRESS.STREET' | translate }}:</strong>
              </td>
              <td style="padding: 2px 5px; vertical-align: top; text-align: left">
                {{ address.data.Street }}
              </td>
            </tr>
            <!-- Row 2: Ort and PLZ -->
            <tr>
              <td style="padding: 2px 5px; vertical-align: top; white-space: nowrap">
                <strong>{{ 'ASSIGNMENT.ADDRESS.CITY' | translate }}:</strong>
              </td>
              <td style="padding: 2px 5px; vertical-align: top; text-align: left">
                {{ address.data.City }}
              </td>
              <td style="padding: 2px 5px; vertical-align: top; white-space: nowrap">
                <strong>{{ 'ASSIGNMENT.ADDRESS.ZIPCODE' | translate }}:</strong>
              </td>
              <td style="padding: 2px 5px; vertical-align: top; text-align: left">
                {{ address.data.ZipCode }}
              </td>
            </tr>
            <!-- Row 3: Land and Kennz. -->
            <tr>
              <td style="padding: 2px 5px; vertical-align: top; white-space: nowrap">
                <strong>{{ 'ASSIGNMENT.ADDRESS.COUNTRY' | translate }}:</strong>
              </td>
              <td style="padding: 2px 5px; vertical-align: top; text-align: left">
                {{ address.data.Country }}
              </td>
              <td style="padding: 2px 5px; vertical-align: top; white-space: nowrap">
                <strong>{{ 'ASSIGNMENT.ADDRESS.COUNTRYCODE' | translate }}:</strong>
              </td>
              <td style="padding: 2px 5px; vertical-align: top; text-align: left">
                {{ address.data.CountryCode }}
              </td>
            </tr>
            <!-- Row 4: Zone (full width) -->
            <tr>
              <td style="padding: 2px 5px; vertical-align: top; white-space: nowrap">
                <strong>{{ 'ASSIGNMENT.ADDRESS.ZONE' | translate }}:</strong>
              </td>
              <td style="padding: 2px 5px; vertical-align: top; text-align: left" colspan="3">
                {{ address.data.Zone }}
              </td>
            </tr>
          </table>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
